// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTextWithImageFragmentDoc } from './ComponentTextWithImage.fragment.generated';
export const ComponentTextWithImageCarouselFragmentDoc = gql`
    fragment componentTextWithImageCarousel on ComponentTextWithImageCarousel {
  slidePadding
  slides {
    ...componentTextWithImage
  }
}
    ${ComponentTextWithImageFragmentDoc}`;